import { Route } from "@angular/router";
import { AssetsPage } from "app/modules/well-header-information/pages/assets/assets.page";
import { CompanyComponent } from "app/modules/well-header-information/pages/assets/company/company.component";
import { RegionComponent } from "app/modules/well-header-information/pages/assets/region/region.component";
import { FieldComponent } from "app/modules/well-header-information/pages/assets/field/field.component";
import { PlatformComponent } from "app/modules/well-header-information/pages/assets/platform/platform.component";
import { WellsPage } from "app/modules/well-header-information/pages/wells/wells.page";
import { WellComponent } from "app/modules/well-header-information/pages/wells/well/well.component";
import { WellboreComponent } from "app/modules/well-header-information/pages/wells/wellbore/wellbore.component";
import { StringComponent } from "app/modules/well-header-information/pages/wells/string/string.component";

export const whiDashboardRoutes: Route[] = [
    {
        path: 'well-header-info',
        children: [],
    },
];

export const whiDataManagementRoutes: Route[] = [
    {
        path: 'well-header-info',
        children: [
            // {
            //     path: '',
            //     pathMatch : 'full',
            //     redirectTo: 'assets',
            // },
            {
                path: 'assets',
                component: AssetsPage,
                children: [
                    { path: 'company/:companyId', component: CompanyComponent },
                    { path: 'region/:regionId', component: RegionComponent },
                    { path: 'field/:fieldId', component: FieldComponent },
                    { path: 'platform/:platformId', component: PlatformComponent }
                ]
            },
            {
                path: 'wells',
                component: WellsPage,
                children: [
                    { path: 'well/:wellId', component: WellComponent },
                    { path: 'wellbore/:wellboreId', component: WellboreComponent },
                    { path: 'wellString/:wellStringId', component: StringComponent },
                ]
            },
        ],
    },
];

export const whiConfigurationRoutes: Route[] = [
    {
        path: 'well-header-info',
        children: [],
    },
];
